import { DisplayObject, RenderKind } from './DisplayObject';
import type { BitmapData } from './BitmapData';
import { TRect, TWIPS } from '../utils/numeric';

/** flash.display.Bitmap. Hit tests use its rectangle (Flash ignores bitmap alpha for hits). */
export class Bitmap extends DisplayObject {
  /** @internal */ $bitmapData: BitmapData | null;
  /** @internal */ $smoothing: boolean;
  /** @internal */ $pixelSnapping: string;

  constructor(bitmapData: BitmapData | null = null, pixelSnapping: string = 'auto', smoothing: boolean = false) {
    super();
    this.$bitmapData = bitmapData ?? null;
    this.$pixelSnapping = pixelSnapping;
    this.$smoothing = !!smoothing;
  }

  /** @internal */ get $renderKind(): RenderKind {
    return 'bitmap';
  }

  get bitmapData(): BitmapData | null {
    return this.$bitmapData;
  }
  set bitmapData(v: BitmapData | null) {
    this.$bitmapData = v ?? null;
    this.$invalidate();
  }
  get smoothing(): boolean {
    return this.$smoothing;
  }
  set smoothing(v: boolean) {
    this.$smoothing = !!v;
    this.$invalidate();
  }
  get pixelSnapping(): string {
    return this.$pixelSnapping;
  }
  set pixelSnapping(v: string) {
    this.$pixelSnapping = String(v);
  }

  $selfBounds(): TRect {
    const bd = this.$bitmapData;
    if (!bd || bd.$disposed) return { xMin: 0, yMin: 0, xMax: 0, yMax: 0 };
    return { xMin: 0, yMin: 0, xMax: bd.$width * TWIPS, yMax: bd.$height * TWIPS };
  }
}
